import React, { useState } from 'react'

import {
  Avatar,
  Button,
  Card,
  Divider,
  Form,
  Popconfirm,
  Table,
  Tag
} from 'antd'

import HeroModal from '../HeroModal'
import { HeroType } from '../../../../config'
import {
  deleteHero,
  getHeroConfigs
} from '../../../../modules/hero'
import { fetchDocumentPendingByHeroId } from '../../../../modules/document'
import { useDispatch, useSelector } from 'react-redux'
import { HERO_TYPE, STATUS } from '../../../../utils/constants'
import { useDeepEffect } from '../../../../utils/hooks'
import QrCodeModal from '../QrCodeModal'

const GetStatusColor = (status) => {
  let color = ''
  if (status !== null) {
    switch (status.toUpperCase()) {
      case 'REGISTERED':
        color = 'gold'
        break
      case 'PENDING':
        color = 'cyan'
        break
      case 'APPROVED':
        color = 'green'
        break
      case 'SUSPENDED':
        color = 'red'
        break
      case 'DISABLED':
        color = 'volcano'
        break
      default:
        break
    }
  }
  return color
}

export const HeroDocument = ({ form }) => {
  const dispatch = useDispatch()
  const [qrCode, setQrCode] = useState({})
  const [formData, setFormData] = useState({})
  const [visible, setVisible] = useState(false)
  const [visibleQR, setVisibleQR] = useState(false)

  const {heroConfigList, heroDocumentPending } = useSelector(
    (state) => ({
      heroConfigList: state.hero.heroConfigList,
      heroDocumentPending: state.document.heroDocumentPending
    }),
    []
  )

  async function fetch() {
    await dispatch(getHeroConfigs())
    await dispatch(fetchDocumentPendingByHeroId())
  }

  useDeepEffect(() => {
    fetch()
  }, [])

  async function onOk() {
    await setVisible(false)
  }

  async function onClose() {
    await setFormData({})
    await setVisible(false)
  }

  async function onDelete(id) {
    await dispatch(deleteHero(id))
    await dispatch(fetchDocumentPendingByHeroId())
  }

  async function onClick(e, record) {
    e.preventDefault()
    await setFormData(record)
    await setVisible(true)
  }

  async function viewQrCode(e, record) {
    e.preventDefault()
    await setQrCode(record)
    await setVisibleQR(true)
  }

  async function onCloseViewQr(e) {
    e.preventDefault()
    await setQrCode({})
    await setVisibleQR(false)
  }
  
  const columns = [
    {
      title: 'Avatar',
      dataIndex: 'hero.imageUrl',
      key: 'imageUrl',
      width: 80,
      render: (text, record) => (
        <div>
          <Avatar src={text} />
        </div>
      )
    },
    {
      title: 'Email',
      dataIndex: 'hero.email',
      key: 'email'
    },
    {
      title: 'Hero Type',
      dataIndex: 'hero.heroType',
      key: 'heroType',
      render: (name, row) => {
        return <div>{HeroType[name] ? HeroType[name].title : '-'}</div>
      }
    },
    {
      title: 'Circular Hero Name',
      dataIndex: 'hero.name',
      key: 'name'
    },
    {
      title: 'Province',
      dataIndex: 'hero.province',
      key: 'province'
    },
    {
      title: 'Telephone',
      dataIndex: 'hero.tel',
      key: 'telephone'
    },
    {
      title: 'Status',
      dataIndex: 'hero.status',
      key: 'status',
      filters: STATUS.map((status) => ({
        text: status,
        value: status
      })),
      onFilter: (value, record) => record.status === value,
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'QR Code',
      dataIndex: 'hero.qrCode',
      key: 'qrCode',
      render: (text, record) => (
        <a onClick={(e) => viewQrCode(e, record)}>View</a>
      )
    },
    {
      title: 'Document Status',
      dataIndex: 'status',
      key: 'docStatus',
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => onClick(e, record.hero)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.hero.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card>
      <Table
        bordered
        scroll={{ x: 1200 }}
        rowKey={(record) => record.id}
        dataSource={heroDocumentPending}
        columns={columns}
      />

      <QrCodeModal
        visible={visibleQR}
        onClose={onCloseViewQr}
        qrCodeData={qrCode}
      />
      <HeroModal
        heroConfigs={heroConfigList}
        visible={visible}
        onClose={onClose}
        onOk={onOk}
        formData={formData}
        statusOptions={STATUS}
        heroTypeOptions={HERO_TYPE}
      />
    </Card>
  )
}

const WrappedHeroDocument = Form.create({ name: 'HeroDocument' })(HeroDocument)
export default WrappedHeroDocument



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/HeroDocument/index.js